import { render, staticRenderFns } from "./VyungWorkflow.vue?vue&type=template&id=540f2994&"
import script from "./VyungWorkflow.vue?vue&type=script&lang=js&"
export * from "./VyungWorkflow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports